export default "__VITE_ASSET__6cb6c6b4__"